"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAndRefreshSecure = void 0;
const utils_worker_client_1 = require("@gcloud-npm/utils.worker-client");
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const utils_secure_secure_object_2_perso_cookie_1 = require("@gcloud-npm/utils.secure.secure-object-2-perso-cookie");
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const secureStorage = new utils_secure_local_storage_1.default();
const checkAndRefreshSecure = ({ persistedInfo }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const isLogged = (0, utils_common_get_cookie_1.default)("seth-session-logged");
        const { ts } = persistedInfo;
        const now = Date.now();
        const difference = now - ts;
        const refreshTime = 20 * 60 * 1000;
        const shouldRefreshTime = difference > refreshTime;
        const cdnShouldRefreshLogged = isLogged && shouldRefreshTime;
        const cdnShouldRefreshNoLogged = !isLogged && shouldRefreshTime;
        // Check if refresh is needed
        if (cdnShouldRefreshLogged) {
            // Perform refresh
            const postLogginWorker = yield utils_worker_client_1.Workers.getWorker(utils_worker_client_1.WORKER_TYPES.POST_LOGIN);
            const refreshedSecureContent = yield postLogginWorker.getSecure({
                local: Object.assign({}, localStorage),
                cookie: document.cookie,
            });
            // Hay informacion de cliente
            if (refreshedSecureContent.userPq && refreshedSecureContent.userPq.clt) {
                secureStorage.setItem("ts", refreshedSecureContent);
                (0, utils_secure_secure_object_2_perso_cookie_1.setPersoCookieUsing)(refreshedSecureContent);
            }
        }
        // comming soon for example: refreshing X
        if (cdnShouldRefreshNoLogged) {
        }
    }
    catch (e) {
        console.error(e);
    }
});
exports.checkAndRefreshSecure = checkAndRefreshSecure;
exports.default = exports.checkAndRefreshSecure;
//# sourceMappingURL=index.js.map